
import { Report } from "../../interfaces/intakes.reports"
import { Text, View, Svg, Circle, Path } from "@react-pdf/renderer"
import { globalStyles } from "./DocuPdf";

interface Props {
    data: Report,
}

export const PDFCreatedBy = ({ data }: Props) => {

    const UserSearchIcon = () => (
        <Svg width="10" height="10" viewBox="0 0 24 24" style={{ marginRight: 2 }}>
            <Circle
                cx="10"
                cy="7"
                r="4"
                stroke="#1a9141"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
            <Path
                d="M10.3 15H7a4 4 0 0 0-4 4v2"
                stroke="#1a9141"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
            <Circle
                cx="17"
                cy="17"
                r="3"
                stroke="#1a9141"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
            <Path
                d="m21 21-1.9-1.9"
                stroke="#1a9141"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
        </Svg>
    );

    return (

        <View style={[globalStyles.flexRow, { marginBottom: 6, alignSelf: "flex-start", paddingVertical: 2, paddingHorizontal: 4, borderRadius: 4, backgroundColor: "#cdeece" }]}>
            <UserSearchIcon />
            <Text style={[ globalStyles.bold, { fontSize: 10, color: "#1a9141", marginRight: 2 }]}>
                Created by:
            </Text>
            <Text style={{ fontSize: 10, color: "#1a9141" }}>
                {data.user.name || "--"}
            </Text>
        </View>
    )
}

